import { SideMenuConfig } from './userPlanFeaturesTypes';

export interface Icon {
  id: number;
  documentId: string;
  name: string;
  alternativeText: string | null;
  caption: string | null;
  width: number;
  height: number;
  formats: any | null;
  hash: string;
  ext: string;
  mime: string;
  size: number;
  url: string;
  previewUrl: string | null;
  provider: string;
  provider_metadata: any | null;
  folderPath: string;
  createdAt: string;
  updatedAt: string;
  publishedAt: string | null;
  locale: string | null;
}

export type DynamicComponentType =
  | 'MEETING_ROOM'
  | 'MEETING_ROOM_ROOM'
  | 'FORM'
  | 'FORM_DASHBOARD'
  | null;

export interface FormExtras {
  form_name?: string;
  form_id?: string;
  form_group_name?: string;
  form_group_id?: string;
}

export interface MeetingRoomExtras {
  background?: Icon;
  link?: string | null;
  internal_id?: string;
  vendor_code?: string;
  key?: string;
}

export interface PageRedirectExtras {
  redirect_to: string;
}

export type MenuItemExtras = FormExtras | MeetingRoomExtras | PageRedirectExtras;

export interface Feature {
  id: number;
  documentId: string;
  name: string;
  description: string;
  is_active: boolean;
  dynamic_component: DynamicComponentType;
  extras: MenuItemExtras | null;
  createdAt: string;
  updatedAt: string;
  publishedAt: string | null;
  locale: string | null;
}

export interface MenuItem {
  label: string;
  title?: string;
  subtitle?: string;
  path: string;
  icon: Icon | Icon[] | null;
  isActive: boolean;
  isMobile: boolean;
  rank: number;
  level: 'first' | 'second' | 'third';
  feature: Feature | null;
  subMenu?: MenuItem[];
  code?: string;
  documentId?: string;
  extras?: MenuItemExtras;
}

export type Menu = MenuItem[];

export interface MenuResponse {
  modules: MenuItem[];
  sideMenu: SideMenuConfig;
}

// Tipos auxiliares para verificação de componentes dinâmicos
export const isFormFeature = (
  feature: Feature | null
): feature is Feature & { dynamic_component: 'FORM' | 'FORM_DASHBOARD' } => {
  return feature?.dynamic_component === 'FORM' || feature?.dynamic_component === 'FORM_DASHBOARD';
};

export const isMeetingRoomFeature = (
  feature: Feature | null
): feature is Feature & { dynamic_component: 'MEETING_ROOM' | 'MEETING_ROOM_ROOM' } => {
  return (
    feature?.dynamic_component === 'MEETING_ROOM' ||
    feature?.dynamic_component === 'MEETING_ROOM_ROOM'
  );
};

export const isFormExtras = (extras: MenuItemExtras | null): extras is FormExtras => {
  return (
    extras !== null &&
    ('form_name' in extras || 'form_group_name' in extras || 'form_group_id' in extras)
  );
};

export const isMeetingRoomExtras = (extras: MenuItemExtras | null): extras is MeetingRoomExtras => {
  return (
    extras !== null &&
    ('background' in extras || 'internal_id' in extras || 'vendor_code' in extras)
  );
};

export const isPageRedirectExtras = (
  extras: MenuItemExtras | null
): extras is PageRedirectExtras => {
  return extras !== null && 'redirect_to' in extras;
};
